import { useMutation } from '@tanstack/react-query';

import { apiReturnResults } from '../../apiFactory/apiReturn';
import { Request } from '../../common';
import {
    type ApiResult,
    type BaseParams,
    type CartResponse,
    type CheckoutMethod,
    type CheckoutMethodV2,
    type CheckoutResponseV2,
    type PostParams,
    type ResourceId,
    type UpdateCart,
} from '../../common/structs';
import { links } from '../../links';

export async function getCart(params: BaseParams): Promise<ApiResult<CartResponse>> {
    return Request.getRequest<CartResponse>({
        ...params,
        target: links.cart().single(),
    });
}

export async function deleteCart(params: BaseParams): Promise<ApiResult<CartResponse>> {
    return Request.deleteRequest<CartResponse>({
        ...params,
        target: links.cart().single(),
        settings: {
            ...params.settings,
        },
    });
}

export async function updateCart(params: BaseParams & PostParams<UpdateCart>): Promise<ApiResult<CartResponse>> {
    return Request.postRequest<CartResponse>({
        ...params,
        target: links.cart().single(),
        settings: {
            ...params.settings,
        },
    });
}

export async function checkout(params: BaseParams & PostParams<CheckoutMethod> & { id?: ResourceId }) {
    return Request.postRequest<CartResponse>({
        ...params,
        target: links.cart().checkout(params.id),
        settings: {
            ...params.settings,
        },
    });
}

export async function deleteOrderItem(params: BaseParams & { id: ResourceId }): Promise<ApiResult<CartResponse>> {
    return Request.deleteRequest<CartResponse>({
        ...params,
        target: links.cart().delete(params.id),
        settings: {
            ...params.settings,
        },
    });
}

export async function convertToDraft(params: BaseParams): Promise<ApiResult<CartResponse>> {
    return Request.postRequest<CartResponse>({
        ...params,
        target: links.cart().convertToDraft(),
        value: {},
        settings: {
            ...params.settings,
        },
    });
}

export const V2 = {
    checkout: async function checkoutV2(params: BaseParams & PostParams<CheckoutMethodV2> & { id?: ResourceId }) {
        return Request.postRequest<CheckoutResponseV2>({
            ...params,
            target: links.cart().checkout(params.id),
            settings: {
                ...params.settings,
            },
        });
    },
};

type CheckoutParams = BaseParams & PostParams<CheckoutMethodV2> & { id?: ResourceId };
export const callCheckout = (params: CheckoutParams) => apiReturnResults<CartResponse>(V2.checkout, params);
// TODO revisit & move
export function useCallCheckout() {
    return useMutation(({ value, id }: CheckoutParams) => callCheckout({ value, id }));
}
